export class CreditNote {
  id: number;
  warrantyId: number;
  comments: string;
  refundAmount: number;
  billedDate: Date;
  actionedDate: Date;
  refundDate: Date;
}


